module.exports = __webpack_public_path__ + "media/top_effect.7b905435.mp4";